import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";

export const FounderNote = () => (
  <section id="founder" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="mx-auto max-w-[1000px] px-6 md:px-10">
      <Reveal>
        <p className="overline mb-10">A note from our founder</p>
      </Reveal>

      <Reveal delay={0.05}>
        <blockquote className="font-serif font-light text-3xl md:text-5xl leading-[1.15] tracking-[-0.01em] text-balance">
          “We built ASYA because skincare asks you to believe, then never shows you
          proof. We spent years — and a fortune — guessing. So we engineered a
          system that <span className="text-primary/90 italic">measures</span>, personalizes
          and delivers, then measures again. No more faith. Just your skin, understood.”
        </blockquote>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 flex items-center gap-5">
          <div className="w-14 h-14 rounded-full overflow-hidden border border-white/15 shrink-0">
            <img src={ASSETS.founder} alt="Yoanna Gouchtchina" className="w-full h-full object-cover object-top" />
          </div>
          <div>
            <p className="font-serif italic text-2xl leading-none">Yoanna Gouchtchina</p>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              Founder &amp; CEO · Quantum Origin Inc.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
